"use client"

import { Form, FormItemProps } from "antd";
import { FC } from "react";

const FormItem: FC<FormItemProps> = (props) => {
  return (
    <Form.Item {...props} />
  )
}

FormItem.displayName = 'FormItem'

export default FormItem